
/* ---- Desktop price presets ---- */
document.addEventListener('click', function (e) {
    var preset = e.target.closest('.facets__display .desk-preset, .facets__display-vertical .desk-preset');
    if (!preset) return;
    var minVal = parseInt(preset.dataset.min, 10);
    var maxVal = parseInt(preset.dataset.max, 10);
    var container = preset.closest('.facets__display, .facets__display-vertical');
    if (!container) return;
    container.querySelectorAll('.desk-preset').forEach(function (p) {
        p.classList.toggle('desk-preset--on', p === preset);
    });
    var tMin = container.querySelector('input[id$="-GTE"]');
    var tMax = container.querySelector('input[id$="-LTE"]');
    if (!tMin || !tMax) return;
    tMin.value = String(minVal);
    tMax.value = String(maxVal);
    tMin.dispatchEvent(new Event('change', { bubbles: true }));
});

(function () {
    // KFB — Kymee Filter Bar (mobile only)
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var wrap = document.getElementById('kfbWrap');
    if (!wrap) return;

    var pendingKfbSort = null;

    // Enable filter form for collectParams on mobile
    //   var kfbFF = document.getElementById('kfbFF');
    //   if (kfbFF) kfbFF.removeAttribute('data-kfp-skip'); 

    var currentPane = null;

    /* ---- sync preset active state from URL ---- */
    function syncPresets() {
        var sp = new URLSearchParams(window.location.search);
        var urlMin = parseInt(sp.get('filter.v.price.gte') || '0', 10);
        var urlMax = parseInt(sp.get('filter.v.price.lte') || '0', 10);
        document.querySelectorAll('#kfbPanelForm .kfb-preset').forEach(function (p) {
            var pMin = parseInt(p.dataset.min, 10);
            var pMax = parseInt(p.dataset.max, 10);
            p.classList.toggle('kfb-on', urlMax > 0 && pMin === urlMin && pMax === urlMax);
        });
    }

    /* ---- open a pane ---- */
    function openPane(paneId) {
        currentPane = paneId;

        document.body.style.overflow = 'hidden';
        document.body.classList.add('mobile-filter-overlay');

        wrap.classList.remove('kfb-sort-mode');
        wrap.setAttribute('aria-hidden', 'false');
        wrap.classList.add('is-open');

        requestAnimationFrame(function () {
            document.querySelectorAll('#kfbWrap .kfb-pane').forEach(function (p) {
                p.classList.add('kfb-pane--active');
            });

            // Do this after open so opening does not feel stuck.
            setTimeout(function () {
                syncPresets();
            }, 0);
        });
    }

    /* ---- close button ---- */
    var closeBtn = document.getElementById('kfbClose');
    if (closeBtn) closeBtn.addEventListener('click', closeBar);

    /* ---- clear button (AJAX — no page refresh) ---- */
    var clearBtn = document.getElementById('kfbClear');

    if (clearBtn) {
        clearBtn.addEventListener('click', function () {
            pendingKfbSort = null;

            var resultsUrl = wrap.dataset.resultsUrl || '';
            var baseParams = resultsUrl.includes('?') ? resultsUrl.split('?')[1] : '';
            var ff = document.querySelector('facet-filters-form');

            if (ff && ff.onActiveFilterClick) {
                ff.onActiveFilterClick(baseParams);
            } else {
                window.location.href = resultsUrl || location.pathname;
            }

            closeBar();
        });
    }

    /* ---- close bar ---- */
    function closeBar() {
        wrap.classList.remove('is-open');
        wrap.setAttribute('aria-hidden', 'true');
        currentPane = null;
        document.querySelectorAll('.kfb-pill-btn').forEach(function (b) {
            b.classList.remove('kfb-pill-btn--active');
        });
        setTimeout(function () {
            document.body.style.overflow = '';
            document.body.classList.remove('mobile-filter-overlay');
        }, 360);
    }

    /* ---- pill button clicks ---- */
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.kfb-pill-btn');
        if (!btn || !wrap.contains(btn)) return;

        e.preventDefault();
        e.stopPropagation();

        var pane = btn.dataset.pane || 'kfbPaneAll';

        if (wrap.classList.contains('is-open') && currentPane === pane) {
            closeBar();
        } else {
            openPane(pane);
        }
    });

    /* ---- close on click outside kfbWrap ---- */
    document.addEventListener('click', function (e) {
        if (!wrap.classList.contains('is-open')) return;
        if (wrap.contains(e.target)) return;
        closeBar();
    });

    /* ---- price presets (delegated — survives patchHTML) ---- */
    document.addEventListener('click', function (e) {
        var preset = e.target.closest('#kfbPanelForm .kfb-preset');
        if (!preset) return;

        var minVal = parseInt(preset.dataset.min, 10);
        var maxVal = parseInt(preset.dataset.max, 10);

        document.querySelectorAll('#kfbPanelForm .kfb-preset').forEach(function (p) {
            p.classList.toggle('kfb-on', p === preset);
        });

        var scope = document.getElementById('kfbPanelForm');
        if (!scope) return;

        var tMin = scope.querySelector('input[id$="-GTE"]');
        var tMax = scope.querySelector('input[id$="-LTE"]');
        var rMin = scope.querySelector('.price-range-slider__input--min');
        var rMax = scope.querySelector('.price-range-slider__input--max');
        var dMin = scope.querySelector('[data-price-display="min"]');
        var dMax = scope.querySelector('[data-price-display="max"]');
        var track = scope.querySelector('.price-range-slider__track-active');

        if (!tMin || !tMax || !rMin || !rMax || !track) return;

        var cap = parseInt(rMax.max || maxVal, 10) || maxVal;

        tMin.value = String(minVal);
        tMax.value = String(maxVal);
        rMin.value = String(minVal);
        rMax.value = String(maxVal);

        if (dMin) dMin.textContent = String(minVal);
        if (dMax) dMax.textContent = String(maxVal);

        track.style.left = ((minVal / cap) * 100) + '%';
        track.style.right = (100 - ((maxVal / cap) * 100)) + '%';

        // No dispatchEvent here.
        // Apply button will run AJAX.
    });

    /* ---- sort options (delegated) ---- */

    /* ---- sort options: visual only, apply later ---- */
    document.addEventListener('click', function (e) {
        var opt = e.target.closest('#kfbPaneSort .kfb-sort-opt');
        if (!opt) return;

        var value = opt.dataset.value;
        if (!value) return;

        // Only save sort. Do not apply products/grid here.
        pendingKfbSort = value;

        document.querySelectorAll('#kfbPaneSort .kfb-sort-opt').forEach(function (o) {
            o.classList.toggle('kfb-on', o === opt);
        });

        var select = document.querySelector('select[name="sort_by"]');
        if (select) select.value = value;
    });

    /* ---- Apply button ---- */
    /* ---- Apply button: fast + reliable ---- */
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('#kfbApply');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        if (btn.dataset.loading === '1') return;

        var form = document.getElementById('kfbPanelForm');
        if (!form) return;

        var fd = new URLSearchParams(new FormData(form));

        if (pendingKfbSort) {
            fd.set('sort_by', pendingKfbSort);
        } else {
            var curSort = new URLSearchParams(window.location.search).get('sort_by');
            if (curSort) fd.set('sort_by', curSort);
        }

        fd.delete('page');

        var params = fd.toString();

        btn.dataset.loading = '1';
        btn.classList.add('is-applying');

        // Close instantly for smooth UX.
        closeBar();

        // Best path: use main controller directly.
        if (window.KYMEE_FACETS && typeof window.KYMEE_FACETS.render === 'function') {
            window.KYMEE_FACETS.render(params, {
                updateHistory: true,
                force: true
            });
        } else {
            // Backup path: use desktop controller custom element.
            var ff =
                document.querySelector('#FacetFiltersForm') &&
                document.querySelector('#FacetFiltersForm').closest('facet-filters-form');

            if (ff && typeof ff.onActiveFilterClick === 'function') {
                ff.onActiveFilterClick(params, { force: true });
            } else {
                // Final fallback if JS controller is not ready.
                window.location.href = location.pathname + (params ? '?' + params : '');
            }
        }

        pendingKfbSort = null;
    });

    /* ---- chip toggle visual feedback ---- */
    document.addEventListener('change', function (e) {
        var input = e.target.closest('#kfbPanelForm .kfb-chip-input');
        if (!input) return;
        var label = input.closest('.kfb-chip');
        if (label) label.classList.toggle('kfb-chip--on', input.checked);
    });

    /* ---- sync after AJAX update ---- */
    document.addEventListener('collection:updated', function () {
        // Keep kfbFF enabled so collectParams() picks it up
        //  var kfbFFel = document.getElementById('kfbFF');
        // if (kfbFFel) kfbFFel.removeAttribute('data-kfp-skip');

        // If panel is open, restore all panes to visible
        if (wrap.classList.contains('is-open')) {
            document.querySelectorAll('.kfb-pane').forEach(function (p) {
                p.classList.add('kfb-pane--active');
            });
        }

        // Sync sort checkmarks — fall back to collection default when sort_by absent from URL
        var curSort = new URLSearchParams(window.location.search).get('sort_by');
        var kfbWrap = document.getElementById('kfbWrap');
        var defaultSort = kfbWrap ? kfbWrap.dataset.defaultSort : null;
        var activeSort = curSort !== null ? curSort : defaultSort;
        document.querySelectorAll('.kfb-sort-opt').forEach(function (o) {
            o.classList.toggle('kfb-on', activeSort !== null && o.dataset.value === activeSort);
        });

        var applyBtn = document.getElementById('kfbApply');
        if (applyBtn) {
            applyBtn.dataset.loading = '0';
            applyBtn.disabled = false;
            applyBtn.classList.remove('is-applying');
        }

        // Sync price presets from URL
        syncPresets();
    });

    /* ---- slider move → immediately clear preset active state (capture: fires before stopPropagation) ---- */
    document.addEventListener('input', function (e) {
        if (!e.target.closest('#kfbPanelForm .price-range-slider__input')) return;
        document.querySelectorAll('#kfbPanelForm .kfb-preset').forEach(function (p) {
            p.classList.remove('kfb-on');
        });
    }, true);
})();